/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { NfColumnTypes, NfGridOptions } from '@northfork/ag-grid'
import { formatNumberValue } from '@northfork/basics'

export const HsHPLNumberColDef: ColDef = {
  ...(NfGridOptions.columnTypes?.[NfColumnTypes.Number] ?? {}),
  valueFormatter: (params: ValueFormatterParams) =>
    formatNumberValue(params.value, '1.4-4') ?? '',
}
